import React, { useState } from "react";
import NewPhoneNumber from "@components/forms/NewPhoneNumber";
import styled from "@emotion/styled";
import { FaCheck } from "react-icons/fa";
import { updateCustomerPhone } from "@actions/customerInfo";
import { connect } from "react-redux";
import { FormSection } from "redux-form";
import CustomerBuyAddressNew from "@components/CustomerBuyAddressNew";
import { formatPhone } from "@components/validation/normalize";

const Container = styled.div`
  background-color: ${props => props.bgColor};
  box-shadow: ${props => props.boxShadow};
  border-radius: 10px;
  width: 100%;
  margin-top: 20px;
`;

const Header = styled.div`
  height: 96px;
  border-bottom: 1px solid rgba(119, 121, 132, 0.15);
  display: flex;
  align-items: center;
  padding-left: 7.5%;
  padding-right: 7.5%;

  @media (max-width: 430px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const Circle = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: ${props => props.bgColor};
  font-size: 14px;
  font-weight: bold;
  color: #12b2ea;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeaderText = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 2;
  color: #1f2021;
  margin-left: 20px;

  @media (max-width: 465px) {
    font-size: 16px;
  }
  @media (max-width: 400px) {
    font-size: 15px;
    margin-left: 10px;
  }
  @media (max-width: 335px) {
    font-size: 14px;
  }
  @media (max-width: 310px) {
    font-size: 13px;
  }
`;

const Body = styled.div`
  padding-left: 7.5%;
  padding-right: 7.5%;
  padding-bottom: 35px;
  padding-top: 35px;
`;

const Display = styled.div`
  position: relative;
  height: 72px;
  padding-left: 30px;
`;

const DisplayText = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  position: absolute;
  color: rgba(31, 32, 33, 0.5);
  top: 6px;
  position: absolute;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 1px;
  left: 30px;
  text-transform: uppercase;
  color: rgba(31, 32, 33, 0.5);
`;

const Button = styled.div`
  height: 60px;
  border-radius: 36px;
  font-size: 16px;
  font-weight: bold;
  margin: 0 auto;
  cursor: ${props => (props.valid ? "pointer" : "not-allowed")};
  box-shadow: ${props =>
    props.valid ? "0 9px 18px 0 rgba(57, 200, 118, 0.3)" : "none"};
  background-color: ${props => (props.valid ? "#39c876" : "#f2f2f3")};
  color: ${props => (props.valid ? "#ffffff" : "rgba(119, 121, 132, 0.5)")};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;

  &:hover {
    box-shadow: none;
    background-color: ${props => (props.valid ? "#39c876" : "#f2f2f3")};
  }
`;

const LightDisplay = styled.div`
  font-size: 14px;
  line-height: 1.71;
  color: #777984;
`;

const SellContactInformation = ({
  customerInfo,
  errors,
  updateCustomerPhone,
  phoneValue,
  changePhoneCompleted,
  primaryResidence
}) => {
  const [openForm, changeOpenForm] = useState(!customerInfo.phone);

  const handleContinueClick = async () => {
    if (errors.newPhone) {
      return;
    }
    const result = await updateCustomerPhone(phoneValue.newPhone, true, true);
    if (result === "success") {
      changePhoneCompleted(true);
      changeOpenForm(false);
    }
  };

  return (
    <Container
      bgColor={!openForm ? "#f9f9f9" : "#ffffff"}
      boxShadow={!openForm ? "none" : "0 5px 20px 0 rgba(38, 38, 38, 0.05)"}
    >
      <Header>
        <Circle
          bgColor={
            !openForm ? "rgba(2, 163, 132, 0.1)" : "rgba(18, 178, 234, 0.1)"
          }
        >
          {!openForm ? (
            <FaCheck
              style={{
                color: `rgba(2, 163, 132, 1)`,
                fontSize: "17px"
              }}
            />
          ) : (
            "1"
          )}
        </Circle>
        <HeaderText>Contact Information</HeaderText>
      </Header>
      <Body>
        {!openForm ? (
          <>
            {primaryResidence && (
              <CustomerBuyAddressNew
                customerInfo={primaryResidence}
                noPaddingAndMargin={true}
              />
            )}
            <LightDisplay>{customerInfo.email}</LightDisplay>
          </>
        ) : (
          <Display>
            <Title>Email</Title>
            <DisplayText>{customerInfo.email}</DisplayText>
          </Display>
        )}
        <div>
          {!openForm ? (
            <LightDisplay>{formatPhone(customerInfo.phone)}</LightDisplay>
          ) : (
            <FormSection name="newPhone">
              <NewPhoneNumber />
              <Button
                onClick={handleContinueClick}
                valid={errors.newPhone ? false : true}
              >
                Continue
              </Button>
            </FormSection>
          )}
        </div>
      </Body>
    </Container>
  );
};

export default connect(
  state => ({
    customerInfo: state.customerInfo
  }),
  dispatch => ({
    updateCustomerPhone: (phone, isDefault, resetState) =>
      dispatch(updateCustomerPhone(phone, isDefault, resetState))
  })
)(SellContactInformation);
